import type { CMSTimelineEntry } from '@/lib/cms/types';

import type { TimelineYear } from './Timeline.types';

export const crossfadeTransition = { duration: 0.6, ease: 'easeInOut' as const };

export const readHeaderHeight = (): number =>
  parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0',
    10
  );

export const toTimelineData = (entries: CMSTimelineEntry[]): TimelineYear[] =>
  [...entries]
    .sort((a, b) => a.year - b.year)
    .map((e) => ({
      year: e.year,
      title: e.title || '',
      backgroundImage: e.backgroundImage ?? null,
      popupId: e.cta?.sys.id || null,
    }));
